module.exports = __webpack_public_path__ + "448b6e4eb098abb424af9f28bfa2ff5b.svg";